import PropTypes from "prop-types";

const Admin = ({ tabsConfig, activeTab, onChange, children, ...props }) => {
  return (
    <div className="company__bg-white company__rounded-lg company__border company__border-slate-200">
      <div className="company__border-b company__border-slate-200">
        <nav className="company__flex">
          {tabsConfig?.map((tab) => (
            <button
              key={tab.key}
              onClick={() => onChange?.(tab.key)}
              className={`company__tab company__px-6 company__py-4 company__font-medium ${
                activeTab === tab.key
                  ? "company__tab--active"
                  : "company__text-slate-600"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="company__p-6">{children}</div>
    </div>
  );
};

Admin.propTypes = {
  tabsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ),
  activeTab: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node,
};

export default Admin;
